import React from "react";

import { faRabbitFast } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { add, differenceInMinutes, sub } from "date-fns";

import { Button } from "~/ui";

import type { DateTimeAction } from "../hooks/useDateTimeState";

import styles from "./SpeedyMeetings.module.css";

enum PromptBehaviour {
	END_EARLY = "END_EARLY",
	START_LATE = "START_LATE",
}

interface SpeedyMeetingsProps {
	eventStartDate: Date;
	eventEndDate: Date;
	changeTime: (params: DateTimeAction) => void;
	promptBehaviour: string;
}

export default function SpeedyMeetings({
	eventStartDate,
	eventEndDate,
	changeTime,
	promptBehaviour,
}: SpeedyMeetingsProps) {
	const meetingLengthInMinutes = differenceInMinutes(eventEndDate, eventStartDate);
	const minutesToChange = meetingLengthInMinutes >= 60 ? 10 : 5;

	const onClickPrompt = React.useCallback(() => {
		if (promptBehaviour === PromptBehaviour.END_EARLY) {
			changeTime({
				type: "CHANGE_END",
				newTime: sub(eventEndDate, { minutes: minutesToChange }),
			});
		} else if (promptBehaviour === PromptBehaviour.START_LATE) {
			changeTime({
				type: "CHANGE_START",
				newTime: add(eventStartDate, { minutes: minutesToChange }),
			});
		}
	}, [promptBehaviour, changeTime, eventEndDate, minutesToChange, eventStartDate]);

	if (meetingLengthInMinutes < 30 || meetingLengthInMinutes % 30 !== 0 || meetingLengthInMinutes >= 24 * 60) {
		return null;
	}

	return (
		<Button size="slim" variant="tertiary" className={styles.prompt} onClick={onClickPrompt}>
			<FontAwesomeIcon fixedWidth icon={faRabbitFast} className={styles.promptIcon} />
			<div className={styles.promptText}>Make it speedy</div>
		</Button>
	);
}
